import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BatchImportModel } from '@data-layer/models/common';
import { BatchImportService } from '@shared/batch-import-mutual/services';
import { enumBatchImportItemType } from '@data-layer/enums/common';

@Component({
  selector: 'batch-process-partial-notification',
  templateUrl: './batch-process-partial-notification.component.html',
  styleUrls: ['./batch-process-partial-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchProcessPartialNotificationComponent {
  @Input() public batchItem: BatchImportModel;

  constructor(private batchImportService: BatchImportService) {}

  public onReload(): void {
    this.batchImportService.openSidebar(this.batchItem);
  }

  public get isIsf(): boolean {
    return this.batchItem?.itemType === enumBatchImportItemType.ISF;
  }
}
